+function ($) {
    /* ======= Forms ======= */
    $(document).ready(function(){
        $(".ajax-form").submit(function(e) {
            e.preventDefault();
            let form = $(this);
            let handler = form.data('handler');
            let goal = form.data('goal');


            let data = new FormData();
            //Form data
            let form_data = $(this).serializeArray();
            $.each(form_data, function (key, input) {
                data.append(input.name, input.value);
            });
            // TODO: Переписать чтобы можно было иметь по два поля с файлами в форме
            //File data
            // Я это закомитил, так как форма не работала!
            // let file_data = $(this).find('input[type="file"]')[0].files;
            // for (let i = 0; i < file_data.length; i++) {
            //     data.append("file[]", file_data[i]);
            // }
            //Custom data
            data.append('handler', handler);

            //let data = form.formSerializer({"handler": handler});
            //console.log(file_data);
            //console.log(data);

            $.ajax({
                type: "POST",
                //type: $(this).attr("method"),
                url: "/forms/Sender.php",
                data: data,
                processData: false,
                contentType: false,
                beforeSend: function() {
                    form.find('[type="submit"]').attr('disabled', 'disabled');
                },
                error: function(data) {
                    $(form.data('modal-error')).find('.error-code').html(data.responseText);
                    $(form.data('modal-error')).modal('show');

                    form.trigger('error');
                },
                success: function() {
                    $(form.data('modal-success')).modal('show');
                    form.find('input,textarea').not('[type="submit"]').val('');

                    form.trigger('success', [goal]);
                },
                complete: function(data) {
                    form.find('[type="submit"]').prop('disabled', false);
                    if (form.data('in-modal')) {
                        $(form.data('in-modal')).modal('hide');
                    }
                }
            });
        });
    });
}(jQuery );
